const SIGNED_QUERY_PATTERN = /[?&](X-Amz-|AWSAccessKeyId=|Signature=|Policy=|Key-Pair-Id=)/i;
const CORS_HARDENING_PARAM_PATTERN = /[?&]rve_cors=/;
const CORS_HARDENING_PARAM = "rve_cors=1";

export const withCorsHardenedMediaSrc = (src: string, enabled: boolean): string => {
  if (!enabled || SIGNED_QUERY_PATTERN.test(src) || CORS_HARDENING_PARAM_PATTERN.test(src)) {
    return src;
  }

  const hashIndex = src.indexOf("#");
  const urlWithoutHash = hashIndex === -1 ? src : src.slice(0, hashIndex);
  const hash = hashIndex === -1 ? "" : src.slice(hashIndex);
  const separator = urlWithoutHash.includes("?") ? "&" : "?";

  return `${urlWithoutHash}${separator}${CORS_HARDENING_PARAM}${hash}`;
};
